import React from 'react';
import { useExternalLoginProviders } from '@jwp/ott-hooks-react/src/useExternalLoginProviders';

import LoginExternalForm from '../../../components/LoginExternalForm/LoginExternalForm';
import LoadingOverlay from '../../../components/LoadingOverlay/LoadingOverlay';

const LoginExternal = () => {
  const { data, isLoading } = useExternalLoginProviders(window.location.href.split('?')[0]);

  if (isLoading) {
    return (
      <div style={{ height: 300 }}>
        <LoadingOverlay inline />
      </div>
    );
  }

  return <LoginExternalForm providers={data || []} />;
};

export default LoginExternal;
